require('lib/console-polyfill.js');
require('lib/es5-shim.js');
require('lib/jquery.html5-placeholder-shim.js');
require('lib/url.js');



if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/lib/polyfills.js
// module id = 43
// module chunks = 1